import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var iconNoPhoto =
/*#__PURE__*/
// eslint-disable-next-line react/forbid-elements
_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "53",
  height: "63",
  viewBox: "0 0 53 63",
  children: [/*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("path", {
      id: "no-photo-a",
      d: "M.273.114h44.711v40.87H.273"
    })
  }), /*#__PURE__*/_jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/_jsx("text", {
      fill: "#999",
      fontFamily: "Lato, Lato",
      fontSize: "12",
      fontWeight: "bold",
      children: /*#__PURE__*/_jsx("tspan", {
        x: "0",
        y: "59",
        children: "\u041D\u0435\u0442 \u0444\u043E\u0442\u043E"
      })
    }), /*#__PURE__*/_jsxs("g", {
      transform: "translate(5)",
      children: [/*#__PURE__*/_jsx("mask", {
        id: "no-photo-b",
        fill: "#fff",
        children: /*#__PURE__*/_jsx("use", {
          xlinkHref: "#no-photo-a"
        })
      }), /*#__PURE__*/_jsx("path", {
        fill: "#999",
        d: "M30.073 26.1l1.264 5.4 6.775 1.485a.725.725 0 0 0 .866-.542L44.967 5.95a.714.714 0 0 0-.55-.852L21.762.131a.725.725 0 0 0-.865.542l-1.576 6.972 2.35-.534.876-3.88a.726.726 0 0 1 .866-.542L41.82 6.724c.39.086.637.467.55.852l-4.413 19.521a.725.725 0 0 1-.865.542l-7.019-1.538z",
        mask: "url(#no-photo-b)"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#999",
        d: "M30.427 14.603c1.046.185 2.08-.34 2.341-1.462.276-1.184-.454-2.107-1.446-2.323-1.148-.25-2.12.38-2.383 1.445-.256 1.034.436 2.103 1.488 2.34m-1.712 5.7l.248.787c.833-.907 1.612-1.753 2.389-2.601.832-.907 1.65-1.828 2.499-2.719.705-.738 1.151-1.575 1.29-2.59.133-.967-.053-1.86-.56-2.674-.828-1.327-2.05-2.033-3.644-2.083-1.105-.034-2.08.332-2.9 1.033-.7.598-1.153 1.314-1.361 2.138l2.04 8.71zM24.34 7.257c.33 0 .627.223.705.553l6.194 26.447a.714.714 0 0 1-.544.857L8.08 40.25a.723.723 0 0 1-.87-.536L1.018 13.269a.714.714 0 0 1 .544-.857l22.614-5.136a.721.721 0 0 1 .164-.018zm3.094 23.467a.714.714 0 0 0 .544-.857L23.414 10.38a.726.726 0 0 0-.87-.536L4.17 14.018a.715.715 0 0 0-.544.857L8.19 34.36c.09.385.48.625.87.536l18.374-4.173z",
        mask: "url(#no-photo-b)"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#999",
        d: "M14.418 16.445l3.744 2.295c-.06-.543-.2-.979-.297-1.422-.095-.438-.203-.874-.31-1.333l2.887-.655c.042.145.082.27.112.397.197.833.386 1.669.59 2.5.21.855.44 1.704.649 2.558.046.187.155.293.31.385.795.473 1.589.95 2.381 1.427.115.07.224.148.327.217-.074.293-1.751 2.998-2.328 3.767-.381-.181-.729-.433-1.094-.651-.371-.222-.737-.453-1.105-.68l-1.137-.7-1.104-.68-1.106-.68-1.131-.696c-.282.35-.483.727-.715 1.082-.235.36-.462.725-.692 1.088l-.71 1.12-.691 1.088-.69 1.088-.667 1.049-3.727-2.293 6.504-10.271",
        mask: "url(#no-photo-b)"
      })]
    })]
  })]
});